import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId, action } = body;
    
    console.log(`👥 Updating user ${userId} with action: ${action}`);
    
    if (!userId || !action) {
      return NextResponse.json(
        { error: 'User ID and action are required' },
        { status: 400 }
      );
    }
    
    if (!['suspend', 'activate', 'delete'].includes(action)) {
      return NextResponse.json(
        { error: 'Action must be suspend, activate, or delete' },
        { status: 400 }
      );
    }
    
    const { pool } = await import('@/lib/db');
    
    if (action === 'delete') {
      // Soft delete - mark as deleted
      await pool.execute(
        'UPDATE users SET status = ?, updated_at = NOW() WHERE id = ?',
        ['deleted', userId]
      );
      
      console.log(`✅ User ${userId} marked as deleted`);
      
      return NextResponse.json({
        success: true,
        message: 'User deleted successfully'
      });
    } else if (action === 'suspend') {
      await pool.execute(
        'UPDATE users SET status = ?, updated_at = NOW() WHERE id = ?',
        ['suspended', userId]
      );
      
      console.log(`✅ User ${userId} suspended`);
      
      return NextResponse.json({
        success: true,
        message: 'User suspended successfully'
      });
    } else if (action === 'activate') {
      await pool.execute(
        'UPDATE users SET status = ?, updated_at = NOW() WHERE id = ?',
        ['active', userId]
      );
      
      console.log(`✅ User ${userId} activated`);
      
      return NextResponse.json({
        success: true,
        message: 'User activated successfully'
      });
    }
    
  } catch (error) {
    console.error('❌ Error updating user:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to update user: ' + errorMessage },
      { status: 500 }
    );
  }
}
